import { FormWrapper } from 'components/formWrapper/formWrapper'
import { LoadingContainer } from 'components/loadingContainer'
import { useEventsAdmin } from 'hooks/admin/useEvents'
import { useEventByIdAdmin } from 'hooks/admin/useEvents/useEventById'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { EventWizard } from './components/eventWizard'

export const EventFormPage: React.FC = () => {
    const { id } = useParams<{ id?: string }>()
    const { data, isLoading, error } = useEventByIdAdmin(id || '')
    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const partnerId = searchParams.get('partnerId') || undefined
    const { data: orgData, isLoading: isOrgDataLoading, error: orgDataError } = useOrganizations()
    const partnerName = React.useMemo(() => orgData?.find((org) => org.org_id === partnerId)?.name, [partnerId, orgData])
    const { handleDelete } = useEventsAdmin(partnerId)

    const handleClose = () => {
        if (partnerId) {
            const url = `/admin/esemenyek/szervezet/${partnerId}`
            navigate(url)
        } else {
            navigate('/admin/esemenyek')
        }
    }

    const handleDeleteClick = async () => {
        if (id) {
            await handleDelete(id)
            navigate('/admin/esemenyek')
        }
    }

    useEffect(() => {
        if (id && !data && !isLoading) navigate('/hiba/404')
    }, [id, data, isLoading, navigate])

    return (
        <LoadingContainer isLoading={isOrgDataLoading} error={orgDataError}>
            <FormWrapper onClose={handleClose} partnerName={partnerName}>
                <LoadingContainer isLoading={isLoading} error={error}>
                    <EventWizard initialData={data} onDelete={data ? handleDeleteClick : undefined} partnerId={partnerId} />
                </LoadingContainer>
            </FormWrapper>
        </LoadingContainer>
    )
}
